export const DEFAULT_PLAY_LIST = 'PLkStynI2GBQcup1nXTpM2UbxOOgGS1qIr'
export const tabs = [
  {
    name: 'Tutorial',
    playListId: DEFAULT_PLAY_LIST,
    icon: 'tutorial_video',
  },
  {
    name: 'Help articles',
    icon: 'documents',
    redirect: 'https://help.ahaslides.com/portal/en/home',
  },
  {
    name: 'Community',
    icon: 'community',
    redirect: 'https://www.facebook.com/groups/AhaSlides/',
  },
  {
    name: 'Request a feature',
    icon: 'request',
    redirect: 'https://help.ahaslides.com/portal/en/community/ahaslides/filter/idea/',
  },
  {
    name: 'Integrations',
    icon: 'integrations',
    redirect: '/apps/integrations',
  },
]
export const TRACKING = {
  PRESENTATION_EDITOR: 'Presentation Editor',
  PRESENTATION_LIST: 'Presentation List',
}
